import axios from 'axios';
import urlConfig from '../../public/js/config'; // 路径配置
import {getToken} from '@/util/auth';

// 创建axios 实例
const service = axios.create({
    baseURL: urlConfig.gateWayUrl, // api的base_url
    timeout: 50000, // 请求超时时间
    headers: {
        'Cache-Control': 'no-cache',
    },
});

export default service;

